var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#be0027",
    fillRule: "evenodd",
    d: "M0 0h53.3v40H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b5aa3",
    fillRule: "evenodd",
    d: "M2.1 2.3h49.2V38H2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cbe0e5",
    fillRule: "evenodd",
    d: "M26.2 34.4h.7a16.4 16.4 0 0 0 0-28.8h-.7a16.6 16.6 0 0 0 0 28.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#add2d9",
    fillRule: "evenodd",
    d: "M26.2 34.7q.3.3.7 0c8.5-6.3 8.5-10.2 8.1-10.2H18.3c-.3 0 .1 4 7.9 10.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdf9a1",
    fillRule: "evenodd",
    d: "M19.6 27.6q1.2-.3 2.3.1.8.5 1.7.4c.7 0 1.3.5 2 .5 1.5 0 2 .8 1 .8-.5 0-1.7-.4-2.2-.3q-1.5 0-3 1.6l1.3.8c1-.4 1.3-1 1.8-1 .7 0 1-.4 1.7-.4q1.5.1 2.8-.2c1.2-.3.6-1.2-.1-1.5-.6-.2-1.8 0-2.5-.3-.5-.2 0-.5.2-.6l1 .1h2c1.1-.2 1.1-.6 1.6-.6q.7 0 1-.3.5-.6 1.1-.7h1L33 29.5l-4.2 4.3-2.2.9-4.9-3.2-2.4-3.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#179a3b",
    fillRule: "evenodd",
    d: "M25.1 24.3h9.7l.2-.9h-.6l-1.4.3c-.3 0-.6-.5-.9-.5-.5 0-.5.5-1 .5l-1-.3c-.5 0-.5.3-1.1.3-.9 0-1.2-.8-1.9-.8-1.1 0-1.1 1.1-2 1.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdf9a1",
    fillRule: "evenodd",
    d: "M25.1 24.5h10v-.3H24.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a79270",
    fillRule: "evenodd",
    d: "M29.2 27.5q.1.8 1 1c.6.1 1.5-.5 1-1s-1.2-.7-1.7-1.2c-1-1-2.6-3.6-2.6-5.3l-.2-7.6c0-.2-.5.5-.5.7l.1 7.2c.2 2 1 3.2 1.9 4.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0728",
    d: "m23.8 19.9-.1-.3a1 1 0 0 0-.8-.4 1 1 0 0 0-.9.6v1.4l.4.4.5.1h.5l.3-.4.1-.5h.1-.9v-.3h1.2v.3q0 .4-.2.7 0 .3-.4.4l-.7.2-.7-.2q-.3-.1-.5-.6l-.1-.8v-.7l.3-.5a1 1 0 0 1 1-.4l.8.3.5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.8 19.9h-.1v.1zm-.1-.3-.2.1zm-.2-.2-.1.1m-.3-.1v-.1m-1.2.5h.2zm1.7 1.5h-.1zm.1-.5v-.1h-.1zm.1 0v.2-.3zm-.9 0h.1v.2h.1zm0-.3v-.1h.1zm1.2 0h.1v-.1h-.1m-2.5-.7h-.2zm.2-.5.1.1m2.3.6h.1v.1zm-.3 0-.1-.3-.3.1.2.2zm-.1-.3-.3-.3-.1.2.1.2zm-.3-.3-.2-.1-.1.2.2.1zm-.2-.1h-.4v.2h.3zm-.4 0h-.6l.2.3.4-.1zm-.6 0-.4.5.3.2q0-.3.3-.4zm-.4.5-.1.8h.2q0-.5.2-.6zm-.1.8.1.7h.3l-.2-.7zm.1.7.4.5.2-.2-.3-.4zm.4.5.6.2v-.3l-.4-.1zm.6.2.6-.2-.2-.2H23zm.6-.2.3-.3-.2-.2-.3.3zm.3-.3.2-.6h-.3l-.1.4zm0-.5h.1v-.2zm.1-.2H23v.3h1zm-.8.1v-.3H23v.3zm0-.2h1v-.2h-1zm1-.1v.3h.2v-.3zm0 .3q0 .4-.2.6l.2.1q.3-.3.2-.7zm-.2.6-.4.4.1.2q.4 0 .5-.5zm-.4.4-.6.1v.3q.4 0 .7-.2zm-.6.1-.6-.1-.2.2.8.2zm-.6-.1-.5-.5h-.2q.2.5.5.7zm-.5-.5-.1-.8h-.3q0 .5.2.9zm-.1-.8v-.6l-.2-.1v.7zm0-.6.3-.5-.2-.2-.3.6zm.3-.5.4-.3V19q-.4 0-.6.3zm.4-.3h.5V19h-.6zm.5 0h.4l.1-.3H23zm.4 0 .4.2.1-.2-.4-.3zm.4.2.2.3.2-.2-.3-.3zm.2.3.1.3h.3l-.2-.5zm.3.2h-.4v.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0728",
    d: "M26.3 19h.3v2l-.1.6-.4.4-.7.1-.6-.1-.4-.4-.2-.6v-2h.4v2l.1.4.3.2.4.1h.5l.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.3 19v-.2H26v.1zm.3 0h.2v-.2h-.2zm-.1 2.6-.1-.1m-2.1 0h-.1m-.2-2.7h-.1zm.5 2.5h-.1zm.3.2v.2zm.9 0v.2zM26 19h.4v-.3h-.3zm.3-.2V21h.3v-2zm0 2.1-.1.5.2.1.2-.6zm-.1.5q-.1.2-.4.3l.1.3.5-.5zm-.4.3-.6.2v.2l.7-.1zm-.6.2q-.3 0-.5-.2l-.2.3.7.1zm-.5-.2-.4-.3-.2.1q0 .3.4.5zm-.4-.3-.1-.5H24l.2.6zm-.1-.5v-2H24v2zm-.2-2h.4v-.2H24zm.3 0v2h.2v-2zm0 2v.4h.3V21zm0 .4.4.4.1-.3-.2-.2zm.4.4h.5v-.2H25zm.5 0h.5v-.3l-.5.1zm.5 0 .4-.4H26l-.2.1zm.4-.4V21h-.2v.3zm0-.4v-2h-.2v2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0728",
    d: "M27.4 22H27l1.2-3h.4l1.1 3h-.4l-1-2.6zm.2-1.2h1.6v.4h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.4 22v.2h.1V22m-.4 0-.1.2h.1zm1.2-3v-.2H28v.1m.4 0h-.1m1.1 3v.2h.2V22zm-.4 0h-.1v.2h.1zm-1-2.6h.2v-.1zm-.7 1.4h-.1v.1m1.6 0h.1v-.1zm0 .4h.1v-.1zm-1.6 0h-.1v.1zm-.2.7v.3h.4zm-.2.2 1.1-3.1-.2-.1-1.2 3.1zm1-3h.4v-.3h-.4zm.2-.1 1.2 3h.2l-1.1-3.1zm1.3 3h-.4v.2h.4zm-.3 0-.9-2.6h-.2l.9 2.7zm-1-2.7v.3zm-.2 0-.9 2.7h.3l.9-2.5zm-.6 1.7h1.6v-.3h-1.6zm1.4-.2v.4h.3v-.4zm.2.2h-1.6v.3h1.6zm-1.5.2v-.4h-.2v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0728",
    d: "M30 19h.4l1 2.5 1.1-2.6h.5V22h-.4v-2.3l-1 2.3h-.3l-1-2.3V22h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 19v-.2h-.2v.1zm.4 0v-.2zm1 2.5h-.1v.1h.1m0 0v.1h.1m1.1-2.6h-.1zm.5 3.1v.2zm-.4 0h-.1v.2h.1zm0-2.3h.1v-.2h-.1zm0 0v-.2h-.1v.1m-1 2.3v.2h.1V22m-.3 0H31v.2h.2zm-1-2.3h.1v-.2h-.1zm0 0v-.2H30v.2zm0 2.3v.2h.1V22zm-.4 0v.2h.1zm0-3h.5v-.2H30zm.3 0 1.1 2.6.2-.1-1-2.6zm1.2 2.6v-.2zm.2 0 1-2.6-.2-.1-1 2.6zm1-2.5h.4v-.3h-.5zm.2-.2V22h.3v-3zm.2 3h-.4v.3h.4zm-.3.1v-2.3h-.2V22zm-.1-2.5v.3zm-.1.1-1 2.4h.2l1-2.3zm-.9 2.3h-.3v.3h.3zm-.2 0-1-2.3-.2.1 1 2.4zm-1.1-2.4v.3zm-.2.2V22h.3v-2.3zm.2 2.2H30v.3h.4zm-.2.1v-3h-.3v3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#239e46",
    fillRule: "evenodd",
    d: "M21.6 13.4c0 .3.3 0 .4-.1.6-.2.8-.9 1.8-.5.7.3 1.7.2 1.2.5-.7.4-2 .8-2 2.8q.1.2.2 0c.2-.5 1.2-1.8 1.6-1.7.2 0 .8-.5.8-.3 0 .4-.8 1.4-.8 2.7q.1.5.6.2l.6-.6c.5-.5.4-2.4.5-2.3.4.5.4 2 1 2.5q.8.7.8-.4c-.2-1.4-.9-1-1.2-2.4q0-.5.3-.4.6.1 1 .8l1.3 1.3q1 .4.6-.6-.6-1-1.8-1.5l-1.1-.3q-.3-.1 0-.4.6-.6 1.6-.7c.5 0 1 .5 1.4.6q1.1.1.4-.7c-.3-.3-.9-.8-1.4-.7-1.2.1-1 0-1.8.5q-.4.4-.4.2c.2-.5 0-.4.4-.9q.4-.5.8-.6l.8-.6q.3-.6-.4-.5l-.8.5c-.6.2-1.1 1.5-1.2 1.8q-.1.2-.2-.1c.1-1 .2-2.7-.1-3.3-.6-1-.5-.6-.7 0q-.4 1 0 2.1c0 .4.4.8.4 1 0 .3-.1 0-.2-.1q-.4-.8-1.1-1.1a3 3 0 0 0-1.7-.2c-.2 0 .2.3.3.4l1.5.6.8.7v.7c-.5 0-1.1-.5-2.5-.3q-1 .2-1.7 1.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24.6 25.9h.4v.6h-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdf9ff",
    fillRule: "evenodd",
    d: "M22.6 21.5c1.6 2.2 4.1 3.4 4.2 4.4h-5c1.2-1.3 1.9-2.3.8-4.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a68861",
    fillRule: "evenodd",
    d: "M21.2 26c2.1.4 4.7.7 6.3-.1 0 .5-.5 1.2-1 1.2h-4q.4-.2 1.5-.3h-2.2c-.2 0-.7-.6-.6-.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be0027",
    fillRule: "evenodd",
    d: "M26 35.4q.5.1.8 0a17.6 17.6 0 0 0 0-31H26c-12 6.6-12 24.4 0 31m.1-1.5h.7c10.3-6 10.4-22 0-27.8H26C16.2 12 15.7 27.3 26 34",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd0728",
    d: "m22.4 18.8.5.1q.3.1.4.6H23l-.2-.4h-.4l-.5.1-.2.7.2.6.5.2q.3 0 .5-.2l.1-.5h-.6v-.2h.9v1h-.2v-.2l-.3.2-.5.1-.6-.2q-.3-.3-.3-.8t.3-.8.7-.3m2 0v1.7l.5.2q.4 0 .4-.2l.1-.4v-1.3h.3V20l-.1.6q-.2.3-.7.3-.6 0-.7-.3L24 20v-1.2zm3.8 1.2-.3-.9-.3 1zm-.5-1.2h.4l.7 2h-.3l-.2-.5h-.8l-.2.6H27zm2 0h.5l.5 1.8.6-1.8h.4v2h-.3v-1.7L31 21h-.3l-.6-1.7V21h-.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGu);
export default __webpack_public_path__ + "static/media/gu.6e6f2e49b989ea19242fea6bc8130a6d.svg";
export { ForwardRef as ReactComponent };